import { TransportPrincipalType } from "../enums/transport.enum";

/**
 * CREATE BLACKLIST REQUEST DTO
 * Representa los datos necesarios para crear una entrada en la blacklist
 */
export interface CreateBlacklistClientRequest {
  id: number;
  transport_types: TransportPrincipalType[];
}

export interface CreateBlacklistSubclientRequest {
  id: number;
  transport_types: TransportPrincipalType[];
}

export interface CreateBlacklistRequest {
  driver: number;
  client: CreateBlacklistClientRequest;
  subclients?: CreateBlacklistSubclientRequest[];
}

/**
 * Blacklist Subentity DTO
 * Represents a subentity within a blacklist entry
 */
export class BlacklistSubentityDto {
  client_id: number;
  client_name: string;
  types: TransportPrincipalType[];
  subentities: BlacklistSubentityDto[];

  constructor(data: any = {}) {
    this.client_id = data.client_id || 0;
    this.client_name = data.client_name || '';
    this.types = data.types || [];
    this.subentities = (data.subentities || []).map((sub: any) => new BlacklistSubentityDto(sub));
  }

  static fromJson(json: any): BlacklistSubentityDto {
    return new BlacklistSubentityDto(json);
  }

  toJson(): any {
    return {
      client_id: this.client_id,
      client_name: this.client_name,
      types: this.types,
      subentities: this.subentities.map(sub => sub.toJson())
    };
  }
}

/**
 * Blacklist Entry DTO
 * Represents a blacklist entry for a driver
 */
export class BlacklistEntryDto {
  client_id: number;
  client_name: string;
  types: TransportPrincipalType[];
  subentities: BlacklistSubentityDto[];

  constructor(data: any = {}) {
    this.client_id = data.client_id || 0;
    this.client_name = data.client_name || '';
    this.types = data.types || [];
    this.subentities = (data.subentities || []).map((sub: any) => new BlacklistSubentityDto(sub));
  }

  static fromJson(json: any): BlacklistEntryDto {
    return new BlacklistEntryDto(json);
  }

  toJson(): any {
    return {
      client_id: this.client_id,
      client_name: this.client_name,
      types: this.types,
      subentities: this.subentities.map(sub => sub.toJson())
    };
  }
}

/**
 * Flattened Blacklist Item for table display
 * Represents a single row in the blacklist table
 */
export class BlacklistDisplayItem {
  clientId: number;
  clientName: string;
  clientTypes: TransportPrincipalType[];
  subentities: Array<{
    id: number;
    name: string;
    types: TransportPrincipalType[];
  }>;

  constructor(data: any = {}) {
    this.clientId = data.clientId || 0;
    this.clientName = data.clientName || '';
    this.clientTypes = data.clientTypes || [];
    this.subentities = data.subentities || [];
  }

  static fromBlacklistEntry(entry: BlacklistEntryDto): BlacklistDisplayItem[] {
    const items: BlacklistDisplayItem[] = [];

    // CREAR UNA SOLA FILA POR CLIENTE CON TODAS SUS SUBENTIDADES AGRUPADAS
    const subentities = entry.subentities.map(sub => ({
      id: sub.client_id,
      name: sub.client_name,
      types: sub.types
    }));

    items.push(new BlacklistDisplayItem({
      clientId: entry.client_id,
      clientName: entry.client_name,
      clientTypes: entry.types,
      subentities: subentities
    }));

    return items;
  }
}
